<template>
    <list-item-tpl>
        <el-row :gutter="20">
            <el-col :span="7">
                <el-row :gutter="10">
                    <el-col :span="6">
                        <round-button :type="typeClass" :font-size="24">{{ firstLetter }}</round-button>
                    </el-col>
                    <el-col :span="18">
                        <p class="line-text-1">{{ item.linkman }}</p>
                        <p class="line-text-2">{{ getSourceName(item.companyAbbr) }}</p>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="8">
                <p-icon class="line-text-1" icon-name="phone">{{ item.tel }}</p-icon>
                <p-icon class="line-text-2" icon-name="email">{{ item.email }}</p-icon>
            </el-col>
            <el-col :span="7">
                <p-icon class="line-text-1" icon-name="list">{{ item.companyFullName }}</p-icon>
                <p-icon class="line-text-2" icon-name="clock">{{ item.createTime }}</p-icon>
            </el-col>
            <el-col :span="2">
                <el-button type="primary" style="margin-bottom: 5px;" size="small" @click.prevent="$emit('edit', item)">
                    修改公司信息
                </el-button>
                <router-link :to="{name: 'supplierUsers', query: {id: item.id}}">
                    <el-button size="small">修改人员信息</el-button>
                </router-link>
                <el-button type="danger" style="margin-top: 5px;" size="small" @click.prevent="remove(item.id)">删除当前数据</el-button>
            </el-col>
        </el-row>
        <el-row slot="bottom" class="supplier-bottom">
            <el-col :span="5">
                <label>跟进HR：</label>
                <span>{{ item.applicant }}</span>
            </el-col>
            <el-col :span="5">
                <label>签约部门：</label>
                <span>{{ item.projectName }}</span>
            </el-col>
            <el-col :span="14">
                <label>备注：</label>
                <span>
                    <span v-if="item.remark && item.remark.length > 30">
                        <el-tooltip class="item" effect="dark" :content="item.remark" placement="top-start">
                            <span>{{item.remark.slice(0, 30)}}...</span>
                        </el-tooltip>
                    </span>
                    <span v-else>
                        {{item.remark}}
                    </span>
                </span>
            </el-col>
        </el-row>
    </list-item-tpl>
</template>
<script type="text/javascript">
    import PIcon from 'components/pIcon'
    import ListItemTpl from 'components/listItemTpl'
    import RoundButton from 'components/roundButton'
    import SelectMapMixin from 'mixins/selectMapMixin'
    import typeClass from 'mixins/typeClass'
    import axios from 'axios'
    import CompanyListMixin from './companyList'

    export default {
        props: {
            item: {
                type: Object,
                required: true
            }
        },
        mixins: [SelectMapMixin, typeClass, CompanyListMixin],
        computed: {
            firstLetter () {
                return this.getSourceName(this.item.companyAbbr).substr(0, 1)
            },
            contractDuration () {
                return (this.item.contractStartDate || '-') + ' 至 ' + (this.item.contractEndDate || '-')
            },
            rateTypeText () {
                return this.item.rateType === '1' ? (this.item.price ? '每人' + this.item.price : '-') : this.getSelectMapText('HUNTER_PERSENT', this.item.monthlySalaryPercent) + '*' + this.getSelectMapText('HUNTER_FL', this.item.monthNum)
            }
        },
        methods: {
            remove (id) {
                if (!id) {
                    return
                }
                this.$confirm('是否继续删除该记录?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios.post('/supplier/delete.api', {id: id}, {'X-showMessage': true}).then(() => {
                        this.$emit('remove', id)
                    }).catch(() => {
                    })
                }).catch(() => {
                })
            }
        },
        components: {
            ListItemTpl,
            RoundButton,
            PIcon
        }
    }
</script>
<style type="text/scss">
    .scoped-supplier {
        .list-item {
            .list-item-bottom {
                background : #fafafa;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// listItem.vue?d788a104